// https://stackoverflow.com/a/37511463
export const removeAccents = (s: string): string => s.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
